import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import PropTypes from "prop-types";

import { generateId } from "../../../Utils/FunctionalUtils";

const OnPageMenuSection = ({ properties: { navigation } }) => {
  const [active, setActive] = useState();
  const history = useHistory();

  const renderNavigation = () => {
    return navigation?.map((navigationItem) => {
      const anchorLink = `#${generateId(navigationItem)}`;

      return (
        navigationItem.tx_ahoii_toolkit_section_name && (
          <li key={`key_${anchorLink}`} className="nav-item">
            <a
              className={`nav-link ${anchorLink === active ? "active" : ""}`.trim()}
              href={anchorLink}
              onClick={(e) => {
                e.preventDefault();

                history.push(anchorLink);

                setActive(anchorLink);
              }}
            >
              {navigationItem.tx_ahoii_toolkit_section_name}
            </a>
          </li>
        )
      );
    });
  };

  return (
    <div className="overflow-hidden">
      <div className="container menu-section on-page" data-aos="fade-up">
        <ul className="nav">{renderNavigation()}</ul>
      </div>
    </div>
  );
};

OnPageMenuSection.propTypes = {
  properties: PropTypes.instanceOf(Object),
};

export default OnPageMenuSection;
